"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Banda App API
 * The API for the Banda App
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventLocationControllerApi = exports.EventLocationControllerApiFactory = exports.EventLocationControllerApiFp = exports.EventLocationControllerApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * EventLocationControllerApi - axios parameter creator
 * @export
 */
const EventLocationControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {boolean} [onlyPlaceOfInterest]
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {string} [sortBy]
         * @param {string} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsGet: (onlyPlaceOfInterest, searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/eventLocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (onlyPlaceOfInterest !== undefined) {
                localVarQueryParameter['onlyPlaceOfInterest'] = onlyPlaceOfInterest;
            }
            if (searchField !== undefined) {
                localVarQueryParameter['searchField'] = searchField;
            }
            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsIdDelete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiEventLocationsIdDelete', 'id', id);
            const localVarPath = `/api/eventLocations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiEventLocationsIdGet', 'id', id);
            const localVarPath = `/api/eventLocations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsIdImagePut: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiEventLocationsIdImagePut', 'id', id);
            const localVarPath = `/api/eventLocations/{id}/Image`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} openingHoursId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsIdOpeningHoursOpeningHoursIdDelete: (id, openingHoursId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiEventLocationsIdOpeningHoursOpeningHoursIdDelete', 'id', id);
            // verify required parameter 'openingHoursId' is not null or undefined
            (0, common_1.assertParamExists)('apiEventLocationsIdOpeningHoursOpeningHoursIdDelete', 'openingHoursId', openingHoursId);
            const localVarPath = `/api/eventLocations/{id}/OpeningHours/{openingHoursId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"openingHoursId"}}`, encodeURIComponent(String(openingHoursId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {OpeningHoursPost} openingHoursPost
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsIdOpeningHoursPost: (id, openingHoursPost, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiEventLocationsIdOpeningHoursPost', 'id', id);
            // verify required parameter 'openingHoursPost' is not null or undefined
            (0, common_1.assertParamExists)('apiEventLocationsIdOpeningHoursPost', 'openingHoursPost', openingHoursPost);
            const localVarPath = `/api/eventLocations/{id}/OpeningHours`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(openingHoursPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {OpeningHoursPut} openingHoursPut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsIdOpeningHoursPut: (id, openingHoursPut, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiEventLocationsIdOpeningHoursPut', 'id', id);
            // verify required parameter 'openingHoursPut' is not null or undefined
            (0, common_1.assertParamExists)('apiEventLocationsIdOpeningHoursPut', 'openingHoursPut', openingHoursPut);
            const localVarPath = `/api/eventLocations/{id}/OpeningHours`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(openingHoursPut, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {EventLocationWithoutImage} eventLocationWithoutImage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsIdPut: (id, eventLocationWithoutImage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiEventLocationsIdPut', 'id', id);
            // verify required parameter 'eventLocationWithoutImage' is not null or undefined
            (0, common_1.assertParamExists)('apiEventLocationsIdPut', 'eventLocationWithoutImage', eventLocationWithoutImage);
            const localVarPath = `/api/eventLocations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(eventLocationWithoutImage, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {EventLocationWithoutImage} eventLocationWithoutImage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsPost: (eventLocationWithoutImage, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventLocationWithoutImage' is not null or undefined
            (0, common_1.assertParamExists)('apiEventLocationsPost', 'eventLocationWithoutImage', eventLocationWithoutImage);
            const localVarPath = `/api/eventLocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(eventLocationWithoutImage, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.EventLocationControllerApiAxiosParamCreator = EventLocationControllerApiAxiosParamCreator;
/**
 * EventLocationControllerApi - functional programming interface
 * @export
 */
const EventLocationControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.EventLocationControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {boolean} [onlyPlaceOfInterest]
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {string} [sortBy]
         * @param {string} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsGet(onlyPlaceOfInterest, searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventLocationsGet(onlyPlaceOfInterest, searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsIdDelete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventLocationsIdDelete(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventLocationsIdGet(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsIdImagePut(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventLocationsIdImagePut(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} openingHoursId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsIdOpeningHoursOpeningHoursIdDelete(id, openingHoursId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventLocationsIdOpeningHoursOpeningHoursIdDelete(id, openingHoursId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {OpeningHoursPost} openingHoursPost
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsIdOpeningHoursPost(id, openingHoursPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventLocationsIdOpeningHoursPost(id, openingHoursPost, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {OpeningHoursPut} openingHoursPut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsIdOpeningHoursPut(id, openingHoursPut, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventLocationsIdOpeningHoursPut(id, openingHoursPut, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {EventLocationWithoutImage} eventLocationWithoutImage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsIdPut(id, eventLocationWithoutImage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventLocationsIdPut(id, eventLocationWithoutImage, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {EventLocationWithoutImage} eventLocationWithoutImage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsPost(eventLocationWithoutImage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventLocationsPost(eventLocationWithoutImage, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.EventLocationControllerApiFp = EventLocationControllerApiFp;
/**
 * EventLocationControllerApi - factory interface
 * @export
 */
const EventLocationControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.EventLocationControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {boolean} [onlyPlaceOfInterest]
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {string} [sortBy]
         * @param {string} [sortOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsGet(onlyPlaceOfInterest, searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, options) {
            return localVarFp.apiEventLocationsGet(onlyPlaceOfInterest, searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsIdDelete(id, options) {
            return localVarFp.apiEventLocationsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsIdGet(id, options) {
            return localVarFp.apiEventLocationsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsIdImagePut(id, options) {
            return localVarFp.apiEventLocationsIdImagePut(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} openingHoursId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsIdOpeningHoursOpeningHoursIdDelete(id, openingHoursId, options) {
            return localVarFp.apiEventLocationsIdOpeningHoursOpeningHoursIdDelete(id, openingHoursId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {OpeningHoursPost} openingHoursPost
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsIdOpeningHoursPost(id, openingHoursPost, options) {
            return localVarFp.apiEventLocationsIdOpeningHoursPost(id, openingHoursPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {OpeningHoursPut} openingHoursPut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsIdOpeningHoursPut(id, openingHoursPut, options) {
            return localVarFp.apiEventLocationsIdOpeningHoursPut(id, openingHoursPut, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {EventLocationWithoutImage} eventLocationWithoutImage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsIdPut(id, eventLocationWithoutImage, options) {
            return localVarFp.apiEventLocationsIdPut(id, eventLocationWithoutImage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {EventLocationWithoutImage} eventLocationWithoutImage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventLocationsPost(eventLocationWithoutImage, options) {
            return localVarFp.apiEventLocationsPost(eventLocationWithoutImage, options).then((request) => request(axios, basePath));
        },
    };
};
exports.EventLocationControllerApiFactory = EventLocationControllerApiFactory;
/**
 * EventLocationControllerApi - object-oriented interface
 * @export
 * @class EventLocationControllerApi
 * @extends {BaseAPI}
 */
class EventLocationControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {boolean} [onlyPlaceOfInterest]
     * @param {string} [searchField]
     * @param {string} [searchString]
     * @param {number} [pageSize]
     * @param {number} [pageNumber]
     * @param {string} [sortBy]
     * @param {string} [sortOrder]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventLocationControllerApi
     */
    apiEventLocationsGet(onlyPlaceOfInterest, searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, options) {
        return (0, exports.EventLocationControllerApiFp)(this.configuration).apiEventLocationsGet(onlyPlaceOfInterest, searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventLocationControllerApi
     */
    apiEventLocationsIdDelete(id, options) {
        return (0, exports.EventLocationControllerApiFp)(this.configuration).apiEventLocationsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventLocationControllerApi
     */
    apiEventLocationsIdGet(id, options) {
        return (0, exports.EventLocationControllerApiFp)(this.configuration).apiEventLocationsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventLocationControllerApi
     */
    apiEventLocationsIdImagePut(id, options) {
        return (0, exports.EventLocationControllerApiFp)(this.configuration).apiEventLocationsIdImagePut(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} openingHoursId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventLocationControllerApi
     */
    apiEventLocationsIdOpeningHoursOpeningHoursIdDelete(id, openingHoursId, options) {
        return (0, exports.EventLocationControllerApiFp)(this.configuration).apiEventLocationsIdOpeningHoursOpeningHoursIdDelete(id, openingHoursId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {OpeningHoursPost} openingHoursPost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventLocationControllerApi
     */
    apiEventLocationsIdOpeningHoursPost(id, openingHoursPost, options) {
        return (0, exports.EventLocationControllerApiFp)(this.configuration).apiEventLocationsIdOpeningHoursPost(id, openingHoursPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {OpeningHoursPut} openingHoursPut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventLocationControllerApi
     */
    apiEventLocationsIdOpeningHoursPut(id, openingHoursPut, options) {
        return (0, exports.EventLocationControllerApiFp)(this.configuration).apiEventLocationsIdOpeningHoursPut(id, openingHoursPut, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {EventLocationWithoutImage} eventLocationWithoutImage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventLocationControllerApi
     */
    apiEventLocationsIdPut(id, eventLocationWithoutImage, options) {
        return (0, exports.EventLocationControllerApiFp)(this.configuration).apiEventLocationsIdPut(id, eventLocationWithoutImage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EventLocationWithoutImage} eventLocationWithoutImage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventLocationControllerApi
     */
    apiEventLocationsPost(eventLocationWithoutImage, options) {
        return (0, exports.EventLocationControllerApiFp)(this.configuration).apiEventLocationsPost(eventLocationWithoutImage, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EventLocationControllerApi = EventLocationControllerApi;
